import { Http } from "@/lib/http";
import { URL_PATHS } from "./constants";

export default class LoanSettingsService extends Http {
  constructor() {
    super();
  }
  
  /**
   *  Return a list of branches 
   */
  getBranches() {
    return this.httpClient().get(
      `${URL_PATHS.COMPANY_SETTINGS}/branches`,
    );
  }

  /**
   * Return a list of dsr calculation methods
   * return Array<object>
   */
  getCalculationMethods() {
    return this.httpClient().get(
      `${URL_PATHS.LOANPRO_SETTINGS}/dsr-calculations`,
    );
  }

  /**
   * Return an object of loan general settings
   * returns object
   */
  getGeneralLoanSettings() {
    return this.httpClient().get(
      `${URL_PATHS.LOANPRO_SETTINGS}/general-loan-settings`,
    );
  }

  /**
   *  Return a list of loan loan products
   */
  getLoanProducts() {
    return this.httpClient().get(
      `${URL_PATHS.LOANPRO_SETTINGS}/loan-products`,
    );
  }
  
  /**
   *  Return a list of loan types
   */
  getLoanTypes() {
    return this.httpClient().get(
      `${URL_PATHS.LOANPRO_SETTINGS}/loan-types`,
    );
  }

  getRiskFactors() {
    return this.httpClient().get(
      `${URL_PATHS.GENERAL_SETTINGS}/risk-factors/module/Loan-Pro`,
    );
  }
}
